module.exports = __webpack_public_path__ + "img/smile-disabled.e3fbc4e0.svg";